<template>
  <div class="manngerform mt20">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px"  :show-message="false">
      <el-form-item label="入驻信息" v-if="num!=3">
        <el-col class="ht80 w290">
          <el-input
            v-model="form.content"
            type="textarea"
            :rows="6"
            placeholder="便于我们更好的服务您，请简单描述您的需求或信息"
          ></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="企业名称：">
        <el-col class="ht32 w290">
          <el-input v-model="form.company" placeholder="请输入企业名称"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="联系人：" prop="name">
        <el-col class="ht32 w290">
          <el-input v-model="form.name" placeholder="请输入联系人"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="联系电话：" prop="tel">
        <el-col class="ht32 w290">
          <el-input v-model="form.tel" placeholder="请输入联系电话"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit('form')" class="mage_btn marginauto">递交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: "enterteam",
  props: ["num"],
  data() {
    return {
      userid: localStorage.getItem("userId"),
      form: {
        content: "",
        company:localStorage.getItem("companyName"),
        name: "",//localStorage.getItem("userName"),
        tel: "",//localStorage.getItem("userphone")
      },
      isshow: true,
      rules: {
        name: [{ required: true, message: "请输入联系人" }],
        tel: [
          { required: true, message: "请输入联系电话" },
          {
            pattern: /^1(3|4|5|7|8|9)\d{9}$/,
            message: "请输入合法手机号",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {},
  methods: {
    saveaddress() {
      debugger;
      let data = {
        iType: this.num,
        nvcContent: this.form.content,
        nvcContact: this.form.name,
        nvcContactInformation: this.form.tel,
        dtCreateTime: this.commJs.getTime(),
        iState: -1,
        nvcResourceNode: this.comUrl.nodeCity.resourcePlatform,
        resourcePlatform: this.comUrl.nodeCity.resourcePlatform,
        nvcResourceplatform: this.comUrl.nodeCity.Platform
      };
      this.$axios
        .post(
          "/information/ResourcesService/SavePlatformApply",
          data
        )
        .then(res => {
          debugger;
          console.log(res);
          if (res.data.isSuccess > 0) {
            this.$message({
              message: "提交成功",
              type: "success"
            });
          } else {
            this.$message.error({
              message: res.data.errorMesg
            });
          }
        });
    },
    onSubmit(formName) {
      let that = this;
      debugger;
      that.$refs[formName].validate(valid => {
        if (valid) {
          console.log(valid, "校验");
          this.saveaddress();
          this.$parent.closeAll();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/Public/enterTeam.vue